import React, {useMemo}  from 'react'
import { deadlineObjectChecker } from '../../lib/utils';
import {ViewLabelValueField,VisDiv } from '../../components';
import {DataScadenzaTagliando} from '../../lib/ScadenzeData'



/**
 * Component to display the deadlines for a device.
 * #deadlines
 * @param {object} device - the device object
 * @param {object} deviceTemplate - the device template object
 * @param {object} registerTemplate - the register template object
 * @returns A React component displaying the deadlines for the device
 */
const ScadenzaTagliando = ({device, deviceTemplate, registerTemplate}) => {

    const testing = false
    const data = useMemo(() => (DataScadenzaTagliando(device, deviceTemplate, registerTemplate)),[device,deviceTemplate, registerTemplate]);

    const {expiry, collaudo, revisione, maintenanceTasksList} = data
    const exists = [!!expiry?.date, !!collaudo?.date].some?.(x=>x==true)

    const testFunction = () => {
        console.log(DataScadenzaTagliando(device, deviceTemplate, registerTemplate))
    }

        return (
            <div>

                <VisDiv rules={[testing]}><button onClick={()=>{testFunction()}}>Test deadlines</button></VisDiv>

                { collaudo?.date &&
                <ViewLabelValueField
                    label={collaudo.label}
                    value={ deadlineObjectChecker(collaudo?.dateObject).date}
                    highlight={ deadlineObjectChecker(collaudo?.dateObject).color}

                />}
                 { expiry?.date &&
                <ViewLabelValueField
                    label={expiry?.label}
                    value={ deadlineObjectChecker(expiry?.dateObject).date}
                    highlight={ deadlineObjectChecker(expiry?.dateObject).color}
                /> }

            </div>
        )
    

}

export default ScadenzaTagliando
